import { render, staticRenderFns } from "./CariKartlar.vue?vue&type=template&id=e161f89c&"
import script from "./CariKartlar.vue?vue&type=script&lang=js&"
export * from "./CariKartlar.vue?vue&type=script&lang=js&"
import style0 from "./CariKartlar.vue?vue&type=style&index=0&id=e161f89c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports